import { render, staticRenderFns } from "./InfoTypeIcon.vue?vue&type=template&id=10c50275"
import script from "./InfoTypeIcon.vue?vue&type=script&lang=js"
export * from "./InfoTypeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports